<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-cogs', fontSet: 'fad'}"
	[headerText]="data.audioInputChannel.displayName + (T.CONFIGURATION_EDITOR_AUDIO_CHANNEL_CONFIGURATION_DIALOG_TITLE | translate)"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div class="modal-body">
			<div class="VoiceToTrainerContainer">
				<mat-label class="label">{{ T.CONFIGURATION_EDITOR_AUDIO_CHANNEL_VOLUME_PC | translate }}</mat-label>
				<div class="col">
					<div class="cell">
						<sim-admin-settings-slider-to-editable-slider
							(onValueChanged)="data.audioInputChannel.volumePC = $event"
							[editable]="true"
							[max]="2"
							[min]="0"
							[step]="0.1"
							[value]="data.audioInputChannel.volumePC"
						/>
					</div>
				</div>
			</div>

			<div class="VoiceToTrainerContainer">
				<mat-label class="label">{{ T.CONFIGURATION_EDITOR_AUDIO_CHANNEL_VOLUME_REC | translate }}</mat-label>
				<div class="col">
					<div class="cell">
						<sim-admin-settings-slider-to-editable-slider
							(onValueChanged)="data.audioInputChannel.volumeREC = $event"
							[editable]="true"
							[max]="2"
							[min]="0"
							[step]="0.1"
							[value]="data.audioInputChannel.volumeREC"
						/>
					</div>
				</div>
			</div>

			<div class="VoiceToTrainerContainer">
				<mat-label class="label">{{ T.CONFIGURATION_EDITOR_AUDIO_CHANNEL_VOLUME_BROADCAST | translate }}</mat-label>
				<div class="col">
					<div class="cell">
						<sim-admin-settings-slider-to-editable-slider
							(onValueChanged)="data.audioInputChannel.volumeBroadcast = $event"
							[editable]="true"
							[max]="2"
							[min]="0"
							[step]="0.1"
							[value]="data.audioInputChannel.volumeBroadcast"
						/>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
	<ng-container actions>
		<sim-button
			(onClick)="saveAudioInputChannel()"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.BUTTON_OK"
		/>
	</ng-container>
</sim-basic-material-dialog>
